/**
 * useCardState - State management hook for Card component modal functionality
 */

import { useState, useCallback } from 'react';

export const useCardState = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedCard: null,
  });

  const openModal = useCallback((card) => {
    setModalState({
      isOpen: true,
      selectedCard: card,
    });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      selectedCard: null,
    });
  }, []);

  const toggleModal = useCallback((card) => {
    setModalState(prev => ({
      isOpen: !prev.isOpen,
      selectedCard: card || prev.selectedCard,
    }));
  }, []);

  return {
    modalState,
    openModal,
    closeModal,
    toggleModal,
  };
};
